/**
 * @fileoverview The i18next namespace the legal-page CHROME's bundles register under.
 * @package @puffin-core/legal-content
 *
 * A ZERO-IMPORT leaf module, deliberately: `useLegalContentTranslate()` imports it, and routing the
 * constant through `strings/index.js` would drag `en.js` and `es.js` into every component's import chain
 * for one short string.
 *
 * JSDOC-PROP-CONTRACT-001 PACKAGE-I18N-SEAT U3 (2026-10-23) — namespace #56, issued by the coordinator.
 *
 * @module @puffin-core/legal-content/strings/namespace
 */

/** The canonical namespace under which the legal-page chrome's strings live in i18next. */
export const LEGAL_CONTENT_NAMESPACE = 'legalContent';

export default LEGAL_CONTENT_NAMESPACE;
